import { createFileRoute } from "@tanstack/react-router"

import { LegalVersionPage } from "@/components/content/legal-version-page"
import {
  findLegalVersion,
  lazyLegalModules,
  loadLegalVersion,
  resolveLegalVersions,
} from "@/lib/legal-versions"
import { seoMeta } from "@/lib/seo"

const modules = lazyLegalModules(import.meta.glob("../-content/credit-terms/*.md"))

export const Route = createFileRoute("/_content/credit-terms/$date")({
  loader: ({ params }) => loadLegalVersion(modules, params.date),
  head: ({ loaderData }) => {
    if (!loaderData) return {}
    return seoMeta({
      title: `Credit Terms (${loaderData.dateFormatted})`,
      description: `Archived version of the Entire Credit Terms from ${loaderData.dateFormatted}.`,
      url: `https://entire.com/credit-terms/${loaderData.date}`,
      image: "https://entire.com/og/page/credit-terms.png",
      noindex: true,
    })
  },
  component: CreditTermsVersionPage,
})

function CreditTermsVersionPage() {
  const { asOf, date } = Route.useLoaderData()
  const versions = resolveLegalVersions(modules, asOf)
  const version = findLegalVersion(versions, date)!
  return <LegalVersionPage basePath="/credit-terms" version={version} versions={versions} />
}
